import { gql, useMutation } from "@apollo/client";

const APPROVE_DESIGNER_MUTATION = gql`
  mutation ApproveDesignerApplication($applicationId: ID!) {
    approveDesignerApplication(applicationId: $applicationId)
  }
`;

export const useApproveDesigner = () => {
  const [approveDesigner, { loading, error }] = useMutation(
    APPROVE_DESIGNER_MUTATION,
    {
      refetchQueries: ["getDesignerApplicationList"],
    }
  );

  const handleApproveDesigner = async (applicationId: string) => {
    try {
      const { data } = await approveDesigner({
        variables: { applicationId },
      });
      return data.approveDesignerApplication;
    } catch (err) {
      return { error: "Error occurred while approving designer" };
    }
  };

  return {
    handleApproveDesigner,
    loading,
    error,
  };
};
